





























import { Prop, Component, Vue } from 'vue-property-decorator';

@Component
export default class FitInfoBox extends Vue {
  @Prop({ default: true }) isDot!: boolean;
  @Prop() hidden!: boolean;
  @Prop() value!: string | number;
  @Prop() max!: number;
  @Prop() type!: string;
  // eslint-disable-next-line @typescript-eslint/naming-convention
  @Prop({ default: 'middle' }) AlignType!: string;

  get content() {
    if (this.isDot) return;

    const { value } = this;
    const { max } = this;

    if (typeof value === 'number' && typeof max === 'number') {
      return max < value ? `${max}+` : value;
    }

    return value;
  }
}
